import { getComplianceRegulationInfo } from '../api';

export const isSupportCountry = async (country: string): Promise<boolean> => {
  if (!country) return true;
  // 获取当前用户合规信息
  const regulationInfoRes = await getComplianceRegulationInfo();
  let flag = false;
  if (regulationInfoRes.success && regulationInfoRes.result?.regulationCountry === country) {
    flag = true;
  }
  return flag;
};
